import { render, staticRenderFns } from "./FieldCreator.vue?vue&type=template&id=64cc6073&scoped=true"
import script from "./FieldCreator.vue?vue&type=script&lang=js"
export * from "./FieldCreator.vue?vue&type=script&lang=js"
import style0 from "./FieldCreator.vue?vue&type=style&index=0&id=64cc6073&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cc6073",
  null
  
)

export default component.exports